import { Component, ElementRef, HostListener, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ConfirmationComponent } from '../confirmation/confirmation';
import { Auth } from '../shared/services/auth';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { SharedData } from '../shared/sharedData';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { ActionSuspend } from './employeeActions/actionSuspend';
import { ResetPasswordPage } from './employeeActions/resetPasswordByAdmin';
import { environment } from './../environment';
import { debounceTime } from 'rxjs/operators';
import { DateTimeUtils } from 'app/shared';

@Component({
    selector: 'EmployeesMenu',
    templateUrl: 'employeeList.html',
})

export class EmployeesListingPage {
    public page = 5;
    public endingPage = 0;
    public startingPage = 0;
    public localState = { value: '' };
    public _baseUrl: any;
    public employeeData: any = [];
    public employeePageData: any = [];
    public trackHides = null;
    public designationModel: any = {
        id: null,
        name: ''
    };
    public organizationModel: any = {
        id: null,
        orgName: ''
    };
    public orgName: string = '';
    public desigName: String = '';
    public displayName: String = '';
    public primarySupervisorModel: any = {
        id: null,
        displayName: ''
    };
    public employeeCode: any;
    public showAdvanceSearch: any = false;
    public pageSize: any = 10;
    public showLoading: any = false;
    public currentPage: any;
    public searchData = {
        nameOrCodeOrEmail: '',
        employeeCodes: [],
        excludedEmployeeCodes: [],
        includeEmpIds: [],
        excludeEmpIds: [],
        gradeIds: [],
        mgrLevelIds: [],
        designationIds: [],
        categoryIds: [],
        includeOrgIds: [],
        excludeOrgIds: [],
        supervisorIds: [],
        primarySupervisorIds: [],
        primarySupervisorNameOrCode: null,
        primarySupervisorCods: [],
        employeeStatus: null,
        employeesWithOutSupervisor: null,
        scorecardStates: null,
        memberShipState: null,
        programId: null,
        licenceNumber: '',
        pageSize: 10,
        page: 1,
        fetchSupervisorLevels: 0
    };
    public empInfo: any;
    public data: any;
    public sdgClient: any;
    public client: any;
    public roles: any = [
        'ROLE_USER', 'ROLE_VACCINE_ADMIN',
        'ROLE_VACCINE_SEARCH_ADMIN', 'ROLE_LAB_ADMIN',
        'ROLE_TRACE_HUB_ADMIN', 'ROLE_NIP_ADMIN',
        'ROLE_NIP_SEARCH_ADMIN', 'ROLE_VMS_RESOLVER_ADMIN'];
    public _newRole: any;
    public _newMYSJType: any = 1;
    public _newMYSJCounCode: any = '60';
    public _newMYSJContact: any = '';
    public _newMYSJEmail: any = '';
    public regexEmail = new RegExp('[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\.[a-zA-Z]{2,3}$');

    public employeeModal: any = {};
    public states: any = [];

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public vcr: ViewContainerRef) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.getStates();
        this.getEmployee();
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this.data = JSON.parse(localStorage.userInfo);
        this.empInfo = this.data;
        this.client = environment.client;
    }

    public chage() {
        if (this.empInfo.localeName == null) {
            this.empInfo.localeName = 'en_US';
        }
        document.documentElement.setAttribute('lang', this.empInfo.localeName);
    }

    public addEmployees() {
        this.share.saveData({ employeeId: null, type: 'ADD' });
        this.router.navigate(['menu/addEmployee']);
    }

    // Patch for pop-over issue
    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 10);
        }
    }

    public clicked() {
        this.trackHides = null;
    }

    public closeEmployeeFilter() {
        this._auth.closeFilter();
    }

    // show and hide Advance Search option
    public showAdvanced(e) {
        this.showAdvanceSearch = e;
    }

    public autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.displayName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public autoCompleteListGradeFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.name}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }
    public autoCompleteListOrgFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.orgName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public onStatusChange(e) {
        if (!e || !e.trim()) {
            this.searchData.employeeStatus = null;
            return;
        } else {
            this.searchData.employeeStatus = e;
        }
    }

    public getEmployee() {
        let self = this;
        if (this.searchData.nameOrCodeOrEmail != '' || this.searchData.licenceNumber != '') {
            self.showLoading = true;
            let url = self._baseUrl + 'v1/webAdmin/employee';
            self.http.post(url, this.searchData).subscribe((result) => {
                self.employeeData = [];
                self.employeeData = result.content;
                self.employeePageData = result;
                self.showLoading = false;
            }, (error) => {
                self.showLoading = false;
            });
        }
    }

    public showSearchFilter(event) {
        this.searchData = event;
        this.getEmployee();
    }

    public onPageSizeChange() {
        this.searchData.page = 1;
        this.getEmployee();
    }

    public empTableActions(value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }
    }

    public empTableResetPwd(id) {
        this.trackHides = null;
        this.share.saveData(id);
        const modalRef = this.modalService.open(ResetPasswordPage, { windowClass: 'min-modal' });
    }

    public actionSuspend(id) {
        let closeResult: any;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'SUSPEND' });
        const modalRef = this.modalService.open(ActionSuspend,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirm') {
                    this.getEmployee();
                } else {
                    // this.saveUpdateEmpRules(result);
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public resetToDay0(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'ResetDay0',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public reloadEmployee(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'ReloadEmp',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public addLocationAssessment(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'addLocationAssessment',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {

                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public revertICVerification(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'revertICVerification',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public revertNonVaccineAccount(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'revertNonVaccineAccount',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public resolveCertErrors(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'resolveCertErrors',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            }
            );
    }

    public convertToConfirmedCase(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'convertToConfirmedCase',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            }
            );
    }

    public convertToLowRisk(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'convertToLowRisk',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            }
            );
    }

    public addMentalAssessment(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'addMentalAssessment',
            employeeId: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public actionResign(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'Resign',
            program: id
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                closeResult = `Closed with: ${result}`;
                if (result === 'confirmed') {
                    this.getEmployee();
                }
            }, (reason) => {
                closeResult = `Dismissed`;
            });
    }

    public editEmployeeProfile(id) {
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'EDIT' });
        this.router.navigate(['menu/addEmployee']);
    }

    public activateEmployeeProfile(id) {
        debugger;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'ACTIVATE' });
        this.router.navigate(['menu/addEmployee']);
    }

    public actionSwitchUser(employee) {
        this.trackHides = null;
        this.share.saveData({
            employee,
            type: 'SWITCH'
        });
        this.router.navigate(['menu/switch']);
    }

    public onRefresh() {
        this.getEmployee();
    }

    public notify(event) {
        this._toaster.showInfo("copied '" + event + "' To clipboard");
    }

    public actionRemoveEmployee(username) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'Delete',
            program: username
        };

        this.share.saveData(confirmData);

        const modalRef = this.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result === 'confirmed') {
                this.getEmployee();
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }

    public roleModelRef: any;
    public _activeUserId: any;
    public _activeEmployee: any;
    public openRoleModal(targetModal, id) {
        this._activeUserId = id;
        this._newRole = '';
        this.roleModelRef = this.modalService.open(targetModal);
        this.roleModelRef.result.then((result) => {
        }, (reason) => {
        });
    }

    public changeRole() {
        if (this._newRole == '') {
            return;
        }

        let closeResult: any;

        this.closeRoleModal()
        let confirmData: any = {
            type: 'changeRole',
            employeeId: this._activeUserId,
            data: this._newRole
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result === 'confirmed') {
                this.getEmployee();
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }

    public closeRoleModal() {
        this.roleModelRef.dismiss('');
    }

    public getStates() {
        this.states = [{ "id": "F2E9FBDEBC37B34B837554B13B031629", "orgName": "Perlis", "orgNameLocale": "Perlis", "orgUnitCode": "Perlis", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B5BE732B4F14B74DD", "orgName": "Kedah", "orgNameLocale": "Kedah", "orgUnitCode": "Kedah", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BC5A4EB1F39D06BD1", "orgName": "Perak", "orgNameLocale": "Perak", "orgUnitCode": "Perak", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B3D13C2BCE0D20CDD", "orgName": "Pulau Pinang", "orgNameLocale": "Pulau Pinang", "orgUnitCode": "Pulau Pinang", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B4BDA5B11108D587D", "orgName": "Selangor", "orgNameLocale": "Selangor", "orgUnitCode": "Selangor", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BFCAC6EB02A19356A", "orgName": "Negeri Sembilan", "orgNameLocale": "Negeri Sembilan", "orgUnitCode": "Negeri Sembilan", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BD098B033D39AE184", "orgName": "Melaka", "orgNameLocale": "Melaka", "orgUnitCode": "Melaka", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B6280AA618C717510", "orgName": "Johor", "orgNameLocale": "Johor", "orgUnitCode": "Johor", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BB6A592F0CC41A2E7", "orgName": "Terengganu", "orgNameLocale": "Terengganu", "orgUnitCode": "Terengganu", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B0A228FAC69C5C809", "orgName": "Pahang", "orgNameLocale": "Pahang", "orgUnitCode": "Pahang", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BDF1E8862862ED39F", "orgName": "Kelantan", "orgNameLocale": "Kelantan", "orgUnitCode": "Kelantan", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B062F6DA2A7133810", "orgName": "Sabah", "orgNameLocale": "Sabah", "orgUnitCode": "Sabah", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B83EDC1DC3E5E2E63", "orgName": "Sarawak", "orgNameLocale": "Sarawak", "orgUnitCode": "Sarawak", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B1EDFFC755BC57AE6", "orgName": "WP Kuala Lumpur", "orgNameLocale": "WP Kuala Lumpur", "orgUnitCode": "WP Kuala Lumpur", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BFA7DBEF29D554EEA", "orgName": "WP Labuan", "orgNameLocale": "WP Labuan", "orgUnitCode": "WP Labuan", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BB7D41137BFE09A99", "orgName": "WP Putrajaya", "orgNameLocale": "WP Putrajaya", "orgUnitCode": "WP Putrajaya", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }];
    }

    public openEditModal(targetModal, emp) {
        this._activeUserId = emp.id;
        this._activeEmployee = emp;
        this._newRole = '';

        this._activeEmployee.bkPassportNumber = this._activeEmployee.passportNumber;
        if (this._activeEmployee.dateOfBirth) {
            this._activeEmployee.dateOfBirth = DateTimeUtils.strToIMyDate(this._activeEmployee.dateOfBirth);
        }

        this.roleModelRef = this.modalService.open(targetModal);
        this.roleModelRef.result.then((result) => {
        }, (reason) => {
        });
    }

    public updateEmployee() {
        if (this._activeEmployee.reason == undefined || this._activeEmployee.reason == '') {
            return;
        }

        let data: any = {
            state: this._activeEmployee.orgCode,
            nationality: this._activeEmployee.nationality,
            justification: this._activeEmployee.reason,
            address: this._activeEmployee.address,
            passportNumber: this._activeEmployee.passportNumber,
            postcode: this._activeEmployee.postcode,
        }

        if (this._activeEmployee.dateOfBirth) {
            data.dateOfBirth = DateTimeUtils.imyDateToDate(this._activeEmployee.dateOfBirth);
        }

        let _self = this;
        let url = _self._baseUrl + "v1/webAdmin/employee/updateProfile?employeeId=" + this._activeEmployee.id;
        _self.http.put(url, data).subscribe((result) => {
            setTimeout(() => { _self.activeModal.close('confirmed'); }, 1000);
            if (result.success == true) {
                _self._toaster.showSuccess('Profile updated successfully');
                _self.getEmployee();
            } else {
                _self._toaster.showError('Profile update failes');
            }
        });

        this.closeRoleModal()
    }

    public openChangeIdModal(targetModal, emp) {
        this._activeUserId = emp.id;
        this._activeEmployee = emp;
        this._newRole = '';
        this.roleModelRef = this.modalService.open(targetModal);
        this.roleModelRef.result.then((result) => {
        }, (reason) => {
        });
    }

    public changeMYSJId() {
        let newMYSJId = this._newMYSJCounCode + '' + this._newMYSJContact;
        if (this._newMYSJType == 1 && this._newMYSJContact != '') {
            newMYSJId = this._newMYSJCounCode + '' + this._newMYSJContact;
        } else {
            newMYSJId = this._newMYSJEmail;
        }

        if (newMYSJId == '') {
            return;
        }

        if (this._newMYSJType == 2 && !this.regexEmail.test(newMYSJId)) {
            return;
        }

        let _self = this;
        let url = _self._baseUrl + "v1/webAdmin/employee/transferAccount/" + this._activeEmployee.id;
        _self.http.post(url, { id: newMYSJId }).subscribe((result) => {
            setTimeout(() => { _self.activeModal.close('confirmed'); }, 1000);
            if (result.success == true) {
                _self._toaster.showSuccess('Change MySJ ID: SMS / Mail sent successfully​');
            } else {
                _self._toaster.showError('Change MySJ ID: SMS / Mail  unsuccessful​');
            }
        });

        this.closeRoleModal()
    }

    public toggleIdType() {
        this._newMYSJType = this._newMYSJType == 1 ? 2 : 1;
    }

    public onNationalityChange() {
        if (this._activeEmployee && this._activeEmployee.nationality != 'Malaysian') {
            this._activeEmployee.passportNumber = this._activeEmployee.licenceNumber;
        } else if (this._activeEmployee.bkPassportNumber) {
            this._activeEmployee.passportNumber = this._activeEmployee.bkPassportNumber;
        }
    }

    public removeLabTest(ic) {
        if (ic == '') {
            return;
        }

        let closeResult: any;
        let confirmData: any = {
            type: 'removeLabTest',
            employeeId: this._activeUserId,
            data: ic
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result === 'confirmed') {
                this.getEmployee();
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }

    public removeHSOBadge(ic) {
        if (ic == '') {
            return;
        }

        let closeResult: any;
        let confirmData: any = {
            type: 'removeHSOBadge',
            employeeId: this._activeUserId,
            data: ic
        };
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result === 'confirmed') {
                this.getEmployee();
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }

    public getRoleLabel(value) {
        switch (value) {
            case 'ROLE_USER':
                return 'User';
            case 'ROLE_VACCINE_ADMIN':
                return 'Vaccine Admin';
            case 'ROLE_VACCINE_SEARCH_ADMIN':
                return 'Vaccine Search';
            case 'ROLE_LAB_ADMIN':
                return 'Lab Admin';
            case 'ROLE_TRACE_HUB_ADMIN':
                return 'TraceHub';
            case 'ROLE_ADMIN':
                return 'Administrator';
            case 'ROLE_NIP_ADMIN':
                return 'NIP Admin';
            case 'ROLE_NIP_SEARCH_ADMIN':
                return 'NIP Search';
            case 'ROLE_VMS_RESOLVER_ADMIN':
                return 'VMS Resolver';
            default:
                return 'None';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/employee/employeeList.ts